import { type ToastItem, useToastStore } from "~/stores/ui/toaststore";
import { useHubsStore } from "~/stores/hubsstore";

export default defineNuxtRouteMiddleware((to) => {
  console.debug("validateHub middleware");
  const hubsStore = useHubsStore();
  const hubNames = hubsStore.hubs
    .map((h) => h.name)
    .filter((name) => name !== undefined)
    .map((h) => h.toLowerCase());

  const hubParam = String(to.params.hub || "").toLowerCase();

  if (!hubNames.includes(hubParam)) {
    console.error(`Invalid hub called: ${hubParam}`);
    const toastStore = useToastStore();
    toastStore.addToast({
      id: self.crypto.randomUUID(),
      title: `Not found`,
      body: `Page with hub '${hubParam}' not found`,
      appendToast: false,
      position: "top-center",
      variant: "warning",
      solid: true,
    } as ToastItem);
    return navigateTo("/");
  }
});
